import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import Header from './libs/header';

window.addEventListener('load', function() {
    window.mySwipe = new Swipe(document.getElementById('slider'), {
        startSlide: 0,
        speed: 400,
        auto: 3000,
        draggable: true,
        continuous: true,
        disableScroll: false,
        stopPropagation: false,
        ignore: ".scroller",
    });
    this.document.querySelector('.activities__content .prev').addEventListener('click', function(e) {
        e.preventDefault();
        mySwipe.prev();
    });
    this.document.querySelector('.activities__content .next').addEventListener('click', function(e) {
        e.preventDefault();
        mySwipe.next();
    });
});

window.addEventListener('load', function() {
    var swiper = new Swiper('.swiper-container', {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        speed: 1000,
        slidesPerView: 2,
        initialSlide: 1,
        observer: true,
        observeParents: true,
        coverflowEffect: {
            rotate: 0,
            stretch: 100,
            depth: 220,
            modifier: 1,
            slideShadows: false,
        },
        navigation: {
            nextEl: ".swiper-buttons--next",
            prevEl: ".swiper-buttons--prev",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        breakpoints: {
            1500: {
                coverflowEffect: {
                    stretch: 100,
                    depth: 220
                }
            },
            1200: {
                coverflowEffect: {
                    stretch: 50,
                    depth: 200,
                }
            },
            992: {
                slidesPerView: 2,
                coverflowEffect: {
                    stretch: 40,
                    depth: 200,
                }
            },
            576: {
                slidesPerView: 1,
                coverflowEffect: {
                    stretch: -20,
                    depth: 200
                }
            },
            320: {
                slidesPerView: 1,
                coverflowEffect: {
                    stretch: -20,
                    depth: 200,
                }
            }
        }
    });
    this.document.querySelector('.swiper-button-next').addEventListener('click', () => {
        swiper.slideNext();
    });
    this.document.querySelector('.swiper-button-prev').addEventListener('click', () => {
        swiper.slidePrev();
    })
    const menuItems = document.querySelectorAll('.nav-main .menu-item > a');
    for (let i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener('click', () => {
            document.querySelector('.header__menu').classList.remove('active');
            document.querySelector('.header__ham .ham').classList.remove('active');
        });
    }
});

jQuery(document).ready(function() {
    const header = new Header();
});

// const documentHeight = () => {
//     const doc = document.documentElement
//     doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
// }
// window.addEventListener('resize', documentHeight);
// documentHeight()